import React from "react"

import DownloadLink from "./download-link"

interface ApprovedInsuficientFundsScreenProps {
  creditLimit: number | null
  cartTotal: number | null
}

const ApprovedInsufficientFundsScreen = ({ creditLimit, cartTotal }: ApprovedInsuficientFundsScreenProps) => {
  return (
    <div className="flex h-screen w-full flex-col px-8 pb-8 pt-32">
      <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Tu crédito aprobado es de ${creditLimit}</h1>
      <p className="mb-8 text-ui-fg-base">
        El precio del producto que estás intentando comprar es ${cartTotal}. ¡No te desanimes! Descarga la app y descubre cientos de
        productos en tu rango de precio. Compra a quincenas, haz tus pagos puntualmente y verás que tu límite de crédito crece muy rápido.
      </p>
      <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-nelo-blue via-blue-200 via-blue-300 via-blue-400 to-nelo-blue p-8 shadow-lg">
        <div className="relative z-10">
          <div className="flex justify-center px-4">
            <DownloadLink />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ApprovedInsufficientFundsScreen
